import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'rma-comparison-table-row',
  templateUrl: './comparison-table-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'row',
    class: 'flex w-min min-w-full gap-3 border-b border-steel-10 last:border-b-0',
  },
})
export class ComparisonTableRowComponent {
  readonly label = input.required<string>();
  readonly indented = input(false, { transform: booleanAttribute });
}
